// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b2d03118","395":"f28c9a15"}[chunkId] + ".chunk.js";
};